const idTokenTag = 'id-token'

export const setIdToken = (token: string): void => {
  window.localStorage.setItem(idTokenTag, token)
}

export const getIdToken = (): string => {
  return window.localStorage.getItem(idTokenTag)!
}
